<div class="h-full">
  @if (!!activity.evaluative) {
    <div class="flex w-full flex-row items-center justify-center">
      @if (!!activity.score) {
        <input
          (blur)="handleBlur()"
          app-input
          [(ngModel)]="score"
          (ngModelChange)="onValueChange($event)"
          currencyMask
          [currencyMask]="scoreOptions"
          class="h-8 w-16! rounded-lg border-none text-center text-[14px]! text-black shadow-inner shadow-base-gray-light-800"
          type="text"
          maxlength="5"
        />
        <span class="text-[14px] font-normal">/{{ activity.score }}</span>
      }

      @if (!!activity.scale) {
        <ng-select
          (blur)="handleBlur()"
          app-select
          [(ngModel)]="score"
          (ngModelChange)="onValueChange($event)"
          [items]="activity.scale.items"
          bindValue="sigla"
          bindLabel="descricao"
          [placeholder]="'eclass.selecione' | translate"
          class="w-[120px]"
          [searchable]="false"
          [multiple]="false"
        ></ng-select>
      }
    </div>
  }
</div>
